import { useEffect, useState } from 'react';
import { useAppSelector } from './typedHooks';
import { selectUserDetails } from 'containers/app/appSlice';
import { useLazyGetUserDetailsQuery } from 'containers/app/api';
import { UserDetailsPayload } from 'containers/app/api';

export const useOptimizedUserDetails = () => {
  const user = useAppSelector(selectUserDetails);
  const [trigger, result] = useLazyGetUserDetailsQuery();
  const [isOptimizedLoading, setIsOptimizedLoading] = useState(false);
  const [isOptimizedSuccess, setIsOptimizedSuccess] = useState(false);

  useEffect(() => {
    if (result.isSuccess) {
      setIsOptimizedSuccess(true);
      setIsOptimizedLoading(false);
    }
  }, [result.isSuccess]);

  // Function that wraps the trigger and adds optimization
  const fetchUserDetails = (payload?: UserDetailsPayload) => {
    // If we already have user data with an ID and verification status, don't fetch again
    if (user && user.id && user.verificationStatus) {
      setIsOptimizedSuccess(true);
      return Promise.resolve({ data: user });
    }

    setIsOptimizedLoading(true);
    return trigger(payload);
  };

  return [
    fetchUserDetails,
    {
      ...result,
      isLoading: isOptimizedLoading || result.isLoading,
      isSuccess: isOptimizedSuccess || result.isSuccess
    }
  ] as const; // Use const assertion to preserve the tuple type
};
